var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestValidated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.998,
    height: 32.999,
    viewBox: "0 0 32.998 32.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffb025;stroke:rgba(0,0,0,0);stroke-miterlimit:10;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.717,29.017c-.013-.006-.03,0-.043-.013a.308.308,0,0,1-.045-.049,16.754,16.754,0,1,1,.089.062Zm.621-.371A15.332,15.332,0,1,0,16.331.671,15.334,15.334,0,1,1,7.337,28.646ZM.662,16A15.319,15.319,0,0,0,6.8,28.261l8.87-12.368V.671A15.35,15.35,0,0,0,.662,16Zm15.607.192a.155.155,0,0,0,.013-.032A.2.2,0,0,1,16.269,16.192Zm.013-.032a.3.3,0,0,0,.029-.06A.337.337,0,0,1,16.282,16.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M248.793,142.206V126.983a15.328,15.328,0,0,0-8.869,27.591Z",
    transform: "translate(-233.125 -126.312)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestValidated);
export default __webpack_public_path__ + "static/media/request-validated.50b8bb7ea4c4c3f4cc7e857dba2a47c7.svg";
export { ForwardRef as ReactComponent };